import { HTTPService } from './httpService';

const API = new HTTPService();

export const DashboardAPI = {
  /**
   * Fetch dashboard metrics
   * @param {number} installerId - Installer/specialist ID
   * @param {number} days - Lookback period (7, 30, or 90)
   * @param {number|null} dealerId - Optional dealer ID for dealer-specific view
   */
  getMetrics: async (installerId, days = 30, dealerId = null, locationId = null) => {
    const params = { installerId, days };
    if (dealerId) params.dealerId = dealerId;
    if (locationId && locationId !== 'all') params.locationId = locationId;
    const response = await API.get('/dashboard/metrics', params);
    return response.data;
  }
};
